import { render, staticRenderFns } from "./PickUpPop.vue?vue&type=template&id=1b940450&"
import script from "./PickUpPop.vue?vue&type=script&lang=js&"
export * from "./PickUpPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports